import React from 'react';
import { Controller } from "react-hook-form";
import { Checkbox as MuiCheckbox } from '@mui/material';
import Checkbox_base from '../../../../assets/svgs/Checkbox_base.js';
import Checked_checkbox from '../../../../assets/svgs/Checked_checkbox.js';
import styles from "./Checkbox.module.css";

const Checkbox = ({ name, control, label, defaultValue, color="var(--primaryHeading)" }) => {
  return (
    <div className={styles.checkbox_container}>
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue} // Default to 0 for unchecked
      render={({ field }) => (
        <div className={styles.checkbox}>
          <MuiCheckbox
            checked={field.value === 1} // Interpret 1 as checked
            onChange={(e) => field.onChange(e.target.checked ? 1 : 0)} // Set 1 for checked, 0 for unchecked
            icon={<Checkbox_base color={color} />}
            checkedIcon={<Checked_checkbox color={color} />}
            sx={{
              "&.MuiCheckbox-root": {
                padding: 0,
              },
            }}
          />
        </div>
      )}
    />
    <div>{label}</div>
  </div>
  );
};

export default Checkbox;
